import { Controller } from "@hotwired/stimulus";

// "Min bokning" -- a modal on desktop, a real page navigation on mobile
// (user's explicit call: the full /visa_bokning page is the right shape
// for a small screen, a modal is the right shape once there's room
// beside it). Scoped on <body> (layouts/flygcity_responsive.html.erb)
// since the trigger links live in three separate places (header button,
// header's mobile menu, footer) with no closer common ancestor.
//
// Every "Min bokning" link keeps its real href (front/_footer.html.erb's
// links render identically whether or not this controller exists on the
// page -- see that file's own note: the desktop grid and mobile
// accordion links are shared with brands not on this design yet, where
// this controller simply isn't present and the data-action is an inert
// no-op, same as a plain link). Only intercepted here, and only past the
// md breakpoint the header itself already switches on (matches its own
// hidden/md:inline-block vs md:hidden split for the button/hamburger).
const DESKTOP_QUERY = "(min-width: 768px)";

export default class extends Controller {
  static targets = ["modal"];

  open(event) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;

    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
  }

  close() {
    this.modalTarget.classList.add("hidden");
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close();
  }
}
